import {ModuleWithProviders} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";

export const APP_ROUTES: Routes = [
   
]


// WEBPACK FOOTER //
// ./src/app/components/start/app.routing.ts